<script lang="ts" setup>
import { useI18n } from '#i18n';

import { BrandButton } from '~~base-ui';

type PixFailedEmit = {
  (event: 'try-again'): void;
};

const { t } = useI18n();

const emit = defineEmits<PixFailedEmit>();

function tryAgain() {
  emit('try-again');
}

</script>

<template>
  <section
    :class="$style.pixFailed"
  >
    <img
      alt="pix error"
      src="../../assets/png/pix/pix-error.png"
    >
    <h5 :class="$style.title">
      {{ t('requirement.pix.pixFailed.title') }}
    </h5>
    <div :class="$style.description">
      <p>
        {{ t('requirement.pix.pixFailed.cpfInformed') }}
      </p>
      <p>
        {{ t('requirement.pix.pixFailed.dontWorry') }}
      </p>
      <p>
        {{ t('requirement.pix.pixFailed.tryAgain') }}
      </p>
    </div>
    <BrandButton
      full-width
      data-testid="tryAgainButton"
      @click="tryAgain"
    >
      {{ t('requirement.pix.pixFailed.actions.tryAgain') }}
    </BrandButton>
  </section>
</template>

<style lang="scss" module>
.pixFailed {
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 300px;
  margin-bottom: var(--space-large);
  gap: var(--space-small-x);

  .title {
    margin: 0;
    font-size: var(--font-size-regular);
    font-weight: var(--font-weight-semibold);
  }

  .description {
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;
  }
}

</style>
